<!--
Author:
Description: 房产客户关系参照框
-->
<template>
  <el-dialog
    class="com-populregister-ref"
    top="10vh"
    title="客户参照"
    :before-close="handleCancel"
    :close-on-click-modal="false"
    v-dialogDrag
    :modal="false"
    :width="width"
    v-bind="{...$props, ...$attrs}"
    style="margin-top:60px;"
  >
    <el-form :inline="true" :model="condition" size="mini" label-suffix=":" style="margin-top: 20px;">
      <el-form-item label="房源名称">
        <el-input v-model="condition.houseName" placeholder="模糊查询" clearable></el-input>
      </el-form-item>
      <el-form-item label="客户名称">
        <el-input v-model="condition.populName" placeholder="模糊查询" clearable></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <div style="padding: 0px 10px;height:360px; padding-bottom: 2em;">
      <el-table
        :data="pageData.list"
        border
        class="table"
        ref="multipleTable"
        align="center"
        height="100%"
        @row-click="handleRowClick"
        @selection-change="handleSelectionChange"
        :key="multiple ? 'multiple' : 'radio'"
      >
        <el-table-column width="50" fixed="left" align="center" show-overflow-tooltip v-if="!multiple">
          <template slot-scope="scope">
            <el-radio :label="scope.row.id" v-model="selectedRowId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column width="50" fixed="left" align="center" show-overflow-tooltip v-if="multiple" type="selection"></el-table-column>
        
        <!-- <el-table-column prop="projectName" align="center" label="项目" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="builderName" align="center" label="楼栋" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="commercialTypeName" align="center" label="业态" min-width="180" show-overflow-tooltip sortable></el-table-column> -->
        <el-table-column prop="populName" align="center" label="客户名称" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="houseName" align="center" label="房源名称" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="isOwner" align="center" label="是否业主" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <!-- <el-table-column prop="isChargeObj" align="center" label="是否收费对象" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="checkInDate" align="center" label="入住日期" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="startLeaseDate" align="center" label="租赁开始日期" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="endLeaseDate" align="center" label="租赁结束日期" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="signDate" align="center" label="签约日期" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="createUser" align="center" label="创建人" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="createTime" align="center" label="创建时间" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="updateUser" align="center" label="最后修改人" min-width="180" show-overflow-tooltip sortable></el-table-column>
        <el-table-column prop="updateTime" align="center" label="最后修改时间" min-width="180" show-overflow-tooltip sortable></el-table-column> -->

      </el-table>
      <div data-ignore-class="pagination">
        <pagination
          data-ignore-style="float:right"
          style="text-align: right;margin-top: 10px;"
          :page-list="pageData"
          @pagesearch="handlePage"
        ></pagination>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import accounting from "accounting"; // 数字格式

function newSearchCondition() {
  return {
    // 查询列表数据的条件
    loginUser: window.sessionStorage.getItem("userId"),

    name: undefined,
    phone: undefined,
    existPopul: "",
    firstIsOwner:true
  };
}

export default {
  name: "houseRegisRef",
  data() {
    return {
      condition: newSearchCondition(),
      pageData: {
        list: [],
        pageNumber: 1,
        pageSize: 10,
        totalCount: 0,
        totalPage: 0
      },
      selectedRowId: "", //单选列表选中的id

      selection: [],

    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.condition = newSearchCondition();
        if(this.conditions != undefined){
          this.condition.existPopul = this.conditions.existPopul
        }
        this.search();

        this.selectedRowId = null;
        this.selection = [];
      }
    },
    // conditions(val) {
    //   if(val != {}){
    //     this.condition.existPopul = val.existPopul
    //   }
    // }
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    conditions: {
      type: Object,
      default: () => {}
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    width: {
      type: String,
      default: () => "80%"
    }
  },
  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    handleConfirm() {
      if (this.multiple ? this.selection.length === 0 : !this.selectedRowId) {
        this.$message.warning("请选择数据");
        return;
      }
      this.$emit(
        "confirm",
        this.multiple
          ? this.selection
          : this.pageData.list.find(item => item.id === this.selectedRowId)
      );
    },
    search() {
      if((this.condition.populName!=undefined&&this.condition.populName!="")||(this.condition.houseName!=undefined&&this.condition.houseName!="")){
        return this.$http
        .post(this.api.ProHouseregisGroupByhouseIdCondition, {
          condition: this.condition,
        })
        .then(res => {
          if (res.data && res.data.code === "200") {
            this.pageData.list = res.data.body.records;
            this.pageData.totalCount = 1;
            this.pageData.totalPage = 1;
          }
        });
      }
      this.pageData.pageNumber = 1;
      return this.getData(this.pageData.pageNumber, this.pageData.pageSize);
    },
    getData(number, size) {
      return this.$http
        .post(this.api.ProHouseregisGroupByhouseId, {
          condition: this.condition,
          number: number,
          size: size
        })
        .then(res => {
          if (res.data && res.data.code === "200") {
            this.pageData.list = res.data.body.records;
            this.pageData.totalCount = res.data.body.total;
            this.pageData.totalPage = res.data.body.pages;
          }
        });
    },
    handlePage(number, size) {
      this.pageData.pageNumber = number;
      this.pageData.pageSize = size;
      this.getData(this.pageData.pageNumber, this.pageData.pageSize);
    },
    //行选择
    handleRowClick(row) {
      this.selectedRowId = row.id;
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    }
  },
  mounted() {
    let sysDic = JSON.parse(localStorage.getItem("sysDic") || "{}");
  }
};
</script>

<style scoped lang="less">
// .com-populregister-ref {}
/deep/ .dialog-no-header > .el-dialog__header {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/houseRegis/houseRegisRef.vue